import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { environment } from 'src/environments/environment';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialogRef } from '@angular/material/dialog';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ModalpopService } from '../modalpop.service';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { StateDialogBoxComponent } from '../state-dialog-box/state-dialog-box.component';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-state-data',
  templateUrl: './state-data.component.html',
  styleUrls: ['./state-data.component.scss']
})
export class StateDataComponent implements OnInit {
  StateForm: FormGroup;
  stateList: any;
  state: string;
  list;
  stateform: any;
  StateSearchForm;
  APIService: any;
  dialogRef: MatDialogRef<any>;
  CountryCodeList: any;
  filteredListCountryCode: any;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 20];
  currentPage = 1;
  totalItems = 0;
  sortedData: any[];
  sortColumn: string = '';  // Track the currently sorted column
  sortDirection: string = 'asc';
  SessionNo: any;
  setIntervalSearch: any;
  constructor(public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private dialog: MatDialog,
    private fb: FormBuilder, public router: Router, private httpClient: HttpClient,
    private route: ActivatedRoute, private spinner: NgxSpinnerService,) { this.APIService = environment.serviceUrl; }

  download() {
    const wwe = ['StateCode', 'StateName'];
    this.umsService.downloadFile(this.stateList, 'jsontocsv', wwe);
  }
  ngOnInit(): void {
    if(JSON.parse(sessionStorage.getItem("session")) == null){
      this.fetchSecretData();
    }
    else if(JSON.parse(sessionStorage.getItem("session")) != null){
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo
    }
    window.scroll(0, 0);
    this.getStateData();
    this.list = true;
    this.StateSearchForm = this.fb.group({
      SearchString: new FormControl('')
    });
   
  }

  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo']
      }
    );
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    // const newPageIndex = Math.floor(event.pageSize * event.pageIndex / this.pageSize);
    const newPageIndex = event.pageIndex + 1;
    this.currentPage = newPageIndex;
    this.getStateData();
  }
  
  getStateData() {
    this.spinner.show();
    const payload = {};   
    payload['PageSize'] = this.pageSize;
    payload['PageNumber'] = this.currentPage;
    this.umsService.getState(payload).subscribe(res => {
      this.spinner.hide();
      this.stateList = res.data;
      this.totalItems = res.data[0].TotalRecords;
    }, (ERROR: HttpErrorResponse) => {
      this.stateList = [];
      let data = {}
      this.spinner.hide();
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }
 
  keypress() {
    if(this.setIntervalSearch){
      clearTimeout(this.setIntervalSearch);
    }
    this.setIntervalSearch = setTimeout(()=>{
      this.stateList = [];
      let payload = {}
      payload['SearchString'] = this.StateSearchForm.value['SearchString'];
      payload['PageSize'] = this.pageSize;
      // payload['PageNumber'] = this.currentPage;
      if (payload['SearchString'] === "") {
        payload['PageNumber'] = this.currentPage;
      } else {
        payload['PageNumber'] = 1;
      }
      this.umsService.searchState(payload).subscribe(res => {
        if(res.status){
          this.stateList = res.data;
          this.totalItems = res.data[0].TotalRecords;
        }
        else{
          this.stateList = [];
          this.totalItems = 0;
        }
       
      }, (ERROR: HttpErrorResponse) => {
        this.stateList = [];
      });
    },1000)
    
  }

  redirect(to): void {
    this.router.navigate([to]);
  }

  addnewrecord() {

    const dialogRef = this.dialog.open(StateDialogBoxComponent, {
      width: '75vh',
      data: { key: "New" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data here
      this.getStateData();
      this.StateSearchForm.controls['SearchString'].setValue('');
    });
  }
  editData(k) {
    const dialogRef = this.dialog.open(StateDialogBoxComponent, {
      width: '80vh',
      data: { selected: k, key: "Edit" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data 
      this.getStateData();
      this.StateSearchForm.controls['SearchString'].setValue('');
    });
  }
  deleteData(k) {
    const dialogRef = this.dialog.open(StateDialogBoxComponent, {
      width: '75vh',
      data: { selected: k, key: "Delete" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data here
      this.getStateData();
      this.StateSearchForm.controls['SearchString'].setValue('');
    });
  }

  Print(){
    let submitpayload = this.StateSearchForm.value;
    let payload1 = {}
    payload1['SearchString'] = submitpayload['SearchString'],
    payload1['MenuName'] ='Master-State';
    let jsonString = JSON.stringify(payload1)
    var filter: any;
    filter = {
      "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
      "RptCode": 112,
      "InstName": '',
      "InstNo": this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0,
      "ShId": '',
      "CgCode": '',
      "RollNo": '',
      "Cent": '',
      "TnCode": '',
      "EsId":  '',
      "CsNo": '',
      "PgBreak": '',
      "StrId": '',
      "StrCode": '',
      "RgNo": '',
      "UC": '',
      "Ledger": '',
      "RegnRoll": '',
      "DsCode": '',
      "CoCode": '',
      "SnNo": this.SessionNo,
      "Extra1": jsonString,
    }

    var payload: any;
    payload = filter;
    this.umsService.setData(JSON.stringify(payload));
    this.redirect('reports')
  }

 
}
